module.exports = function getResource(label, vars = []) {
    let resources = {
        exploreTheBrand: 'Découvrir la marque',
        brand: 'Marque'
    };

    return resources[label];
};
